import React from 'react';
import OrderDirectionsEnum from '../../../Enums/OrderDirectionsEnum';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import ButtonRow from '../../../Elements/ButtonRow';
import GeneralSearchStrip from '../../../Elements/GeneralSearchStrip';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import ApolloCustomTriggerSearchParams from './ApolloCustomTriggerSearchParams';
import ApolloCustomTriggerService from '../../../Services/ApolloCustomTriggerService';
import ApolloDataExportItem from '../../../Domain/ApolloCustomTriggerItem';
import ApolloCustomTriggerWindowDescription from './ApolloCustomTriggerWindowDescription';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';

export default class ApolloCustomTriggerAdmin extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);

    this.state = {
      itemList: [],
      loading: true,
      selected: -1,
      selectedItem: null,
      orderBy: 'Id',
      orderDirection: OrderDirectionsEnum.Asc,
      pageNumber: 1,
      numberOfElementsOnAPage: 20,
      numberOfElementsInTheTable: 0,
      shownPanel: ApolloCustomTriggerSearchParams.isThereAnySearchParameter()
        ? ShownPanelsEnum.Search
        : ShownPanelsEnum.None,
      searchItem: new ApolloCustomTriggerSearchParams(),
    };
    this.showPanel = this.showPanel.bind(this);
    this.escFunction = this.escFunction.bind(this);
    this.startSearch = this.startSearch.bind(this);
    this.editPanelOnClose = this.editPanelOnClose.bind(this);

    ApolloDataExportItem.editFunction = this.clickOnEditIcon.bind(this);
  }

  componentDidMount() {
    document.addEventListener('keydown', this.escFunction, false);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.escFunction, false);
  }

  clickOnEditIcon(selectedItem, item) {
    this.setState({
      selectedItem: item,
      shownPanel: ShownPanelsEnum.EditItem,
    });
  }

  startSearch(searchItem) {
    this.setState({
      loading: true,
      searchItem: searchItem,
    });
  }

  escFunction(event) {
    if (event.keyCode === 27) {
      this.setState({
        shownPanel: ShownPanelsEnum.None,
        selected: -1,
        selectedItem: null,
      });
    }
  }

  showPanel(panelId) {
    if (panelId === ShownPanelsEnum.Refresh) {
      this.refresh();
      panelId = ShownPanelsEnum.None;
    }
    panelId = panelId === this.state.shownPanel ? ShownPanelsEnum.None : panelId;
    this.setState({ shownPanel: panelId });
  }

  renderOnePanel(panelId, content) {
    return this.state.shownPanel === panelId ? content : null;
  }

  refresh() {
    this.setState({ searchItem: { ...this.state.searchItem } });
  }

  editPanelOnClose(refresh) {
    this.setState({
      shownPanel: ShownPanelsEnum.None,
      loading: refresh,
    });
    if (refresh) {
      this.refresh();
    }
  }

  renderPanels() {
    return (
      <div>
        <GeneralSearchStrip
          searchItem={this.state.searchItem}
          searchparamsType={ApolloCustomTriggerSearchParams}
          isRefreshDisabled={false}
          isFilterDisabled={false}
          clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
          clickOnOk={(shownPanel, searchItem) => {
            this.setState({
              loading: true,
              searchItem: searchItem,
            });
          }}
          clickOnRefresh={(shownPanel, searchItem) => {
            this.setState({
              loading: true,
              searchItem: searchItem,
            });
          }}
        />
        {this.renderOnePanel(
          ShownPanelsEnum.AddNewItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={new ApolloDataExportItem()}
            clickOnCancel={() => this.editPanelOnClose(false)}
            clickOnSave={() => this.editPanelOnClose(true)}
            windowDescription={ApolloCustomTriggerWindowDescription}
            errorCode='ACTA136'
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.EditItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.state.selectedItem}
            clickOnCancel={() => this.editPanelOnClose(false)}
            clickOnSave={() => this.editPanelOnClose(true)}
            windowDescription={ApolloCustomTriggerWindowDescription}
            errorCode='ACTA145'
          />
        )}
      </div>
    );
  }

  renderButtonsAndPanels() {
    return (
      <>
        <ButtonRow
          colors={[ButtonColorsEnum.Primary]}
          labels={['Create']}
          keys={[ShownPanelsEnum.AddNewItem]}
          icons={['fa-solid fa-plus-circle']}
          roles={['User']}
          value={this.state.shownPanel}
          onClick={this.showPanel}
        />
        {this.renderPanels()}
      </>
    );
  }
  renderSearchStrip() {
    return (
      <GeneralSearchStrip
        searchItem={this.state.searchItem}
        searchparamsType={ApolloCustomTriggerSearchParams}
        isRefreshDisabled={false}
        isFilterDisabled={false}
        clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
        clickOnOk={(shownPanel, searchItem) => {
          this.setState({
            loading: true,
            searchItem: searchItem,
          });
          this.populateData(this.state.orderBy, this.state.orderDirection, this.state.pageNumber, 20, searchItem);
        }}
      />
    );
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.renderButtonsAndPanels()}
        <TabOfDataTable
          type={ApolloDataExportItem}
          shownPanel={this.state.shownPanel}
          serviceFunction={ApolloCustomTriggerService.GetListBySearching}
          convertDBItemsFunction={ApolloCustomTriggerService.ConvertDBItems}
          searchItem={this.state.searchItem}
          errorCode='ACTA208'
        />
      </div>
    );
  }
}
